import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography, IconButton, useTheme } from '@mui/material';
import { People as PeopleIcon, CalendarMonth as CalendarIcon, Assignment as TaskIcon, MoreVert as MoreIcon, Add as AddIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';
import { PageLayout, SectionPaper, Card } from '@ui/components/PageLayout';
const HomeExample = () => {
    const theme = useTheme();
    // Mock data for people
    const peopleData = [
        {
            id: 1,
            name: 'Simon has been working in VDK Groep for 12 years',
            subtitle: '5 min ago',
            avatar: 'S',
            rightAction: 'button',
            buttonText: 'Create Task',
            buttonOnClick: () => console.log('Create Task clicked for Simon')
        },
        {
            id: 2,
            name: 'Simon has been working in VDK Groep for 12 years',
            subtitle: '5 min ago',
            avatar: 'S',
            rightAction: 'dropdown',
            dropdownOptions: [
                { label: 'Zoe', value: 'zoe', onClick: () => console.log('Zoe selected') },
                { label: 'John', value: 'john', onClick: () => console.log('John selected') },
                { label: 'Sarah', value: 'sarah', onClick: () => console.log('Sarah selected') }
            ],
            dropdownPlaceholder: 'Task Assigned: Zoe',
            dropdownOnSelect: (value) => console.log('Task assigned to:', value)
        },
        {
            id: 3,
            name: 'John has been working in VDK Groep for 8 years',
            subtitle: '10 min ago',
            avatar: 'J',
            rightAction: 'button',
            buttonText: 'Create Task',
            buttonOnClick: () => console.log('Create Task clicked for John')
        },
        {
            id: 4,
            name: 'Sarah has been working in VDK Groep for 5 years',
            subtitle: '15 min ago',
            avatar: 'S',
            rightAction: 'dropdown',
            dropdownOptions: [
                { label: 'Mike', value: 'mike', onClick: () => console.log('Mike selected') },
                { label: 'Lisa', value: 'lisa', onClick: () => console.log('Lisa selected') },
                { label: 'Tom', value: 'tom', onClick: () => console.log('Tom selected') }
            ],
            dropdownPlaceholder: 'Task Assigned: Mike',
            dropdownOnSelect: (value) => console.log('Task assigned to:', value)
        }
    ];
    // Mock data for events
    const eventsData = [
        {
            id: 1,
            title: 'VDK Relatiedagen',
            eventDate: 'Aug 28 → Aug 31',
            responses: '25',
            companies: ['Smit Elektrotechniek', 'Basro', 'B.V. Installattie'],
            leftIcon: _jsx(CalendarIcon, {}),
            rightAvatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=32&h=32&fit=crop&crop=face'
        },
        {
            id: 2,
            title: 'Product Launch Event',
            eventDate: 'Sep 15 → Sep 17',
            responses: '42',
            companies: ['TechCorp', 'InnovateLab', 'Future Systems'],
            leftIcon: _jsx(CalendarIcon, {}),
            rightAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face'
        },
        {
            id: 3,
            title: 'Annual Conference',
            eventDate: 'Oct 5 → Oct 7',
            responses: '18',
            companies: ['Global Solutions', 'Enterprise Corp', 'Mega Industries'],
            leftIcon: _jsx(CalendarIcon, {}),
            rightAvatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=32&h=32&fit=crop&crop=face'
        }
    ];
    // Mock data for tasks
    const tasksData = [
        {
            id: 1,
            title: 'Update Documentation',
            subtitle: 'Due: Today',
            description: 'Update API documentation with new endpoints and examples.',
            badge: 'Urgent',
            icon: _jsx(TaskIcon, {})
        },
        {
            id: 2,
            title: 'Code Review',
            subtitle: 'Due: Tomorrow',
            description: 'Review pull requests for the authentication module.',
            badge: 'Medium',
            icon: _jsx(TaskIcon, {})
        },
        {
            id: 3,
            title: 'Bug Fix',
            subtitle: 'Due: This Week',
            description: 'Fix the login issue reported by users on mobile devices.',
            badge: 'Low',
            icon: _jsx(TaskIcon, {})
        },
        {
            id: 4,
            title: 'Performance Optimization',
            subtitle: 'Due: Next Week',
            description: 'Optimize database queries to improve page load times.',
            badge: 'Medium',
            icon: _jsx(TaskIcon, {})
        }
    ];
    return (_jsx(PageLayout, { title: 'Home', rightContent: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) }, children: [_jsx(Typography, { variant: 'body2', sx: { color: theme.palette.text.secondary }, children: "Welcome back, Claudia!" }), _jsx(IconButton, { size: 'small', children: _jsx(MoreIcon, {}) })] }), children: _jsxs(Grid, { container: true, spacing: 3, sx: { height: '100%' }, children: [_jsx(Grid, { item: true, xs: 12, md: 6, sx: { height: '100%' }, children: _jsx(SectionPaper, { title: 'People', leftIcon: _jsx(PeopleIcon, {}), rightIcon: _jsx(AddIcon, {}), scrollable: true, maxHeight: '65dvh', children: _jsx(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: theme.spacing(2),
                                padding: theme.spacing(1, 0)
                            }, children: peopleData.map((person) => (_jsx(Card, { title: person.name, subtitle: person.subtitle, 
                                // leftIcon={
                                //   <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                                //     {person.avatar}
                                //   </Typography>
                                // }
                                variant: 'people', rightAction: person.rightAction, buttonText: person.buttonText, buttonOnClick: person.buttonOnClick, dropdownOptions: person.dropdownOptions, dropdownOnSelect: person.dropdownOnSelect, dropdownPlaceholder: person.dropdownPlaceholder }, person.id))) }) }) }), _jsx(Grid, { item: true, xs: 12, md: 6, sx: { height: '100%' }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2), height: '100%' }, children: [_jsx(SectionPaper, { title: 'Events', leftIcon: _jsx(CalendarIcon, {}), rightIcon: _jsx(AddIcon, {}), scrollable: true, maxHeight: '27dvh', children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }, children: eventsData.map((event) => (_jsx(Card, { title: event.title, eventDate: event.eventDate, responses: event.responses, companies: event.companies, leftIcon: event.leftIcon, rightAvatar: event.rightAvatar, variant: 'event', onClick: () => console.log(`Clicked on ${event.title}`) }, event.id))) }) }), _jsx(SectionPaper, { title: 'Tasks', leftIcon: _jsx(TaskIcon, {}), rightIcon: _jsx(AddIcon, {}), scrollable: true, maxHeight: '27dvh', children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }, children: tasksData.map((task) => (_jsx(Card, { title: task.title, subtitle: task.subtitle, description: task.description, leftIcon: task.icon, rightIcon: _jsx(ArrowIcon, {}), badge: task.badge, variant: 'task', onClick: () => console.log(`Clicked on ${task.title}`) }, task.id))) }) })] }) })] }) }));
};
export default HomeExample;
